import { render, staticRenderFns } from "./ProductDetailFlyout.vue?vue&type=template&id=5bc91cda&scoped=true&"
import script from "./ProductDetailFlyout.vue?vue&type=script&lang=js&"
export * from "./ProductDetailFlyout.vue?vue&type=script&lang=js&"
import style0 from "./ProductDetailFlyout.vue?vue&type=style&index=0&id=5bc91cda&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc91cda",
  null
  
)

export default component.exports